// @ts-ignore
import { HubCoreService, onSocialNetworkConnection, SocialNetworkProfile, User } from '@hub/shared'
import { SqInfinityScroll } from '@squidit/react-css'
import BannerSocialNetwork from '@src/components/banner-social-network/banner-social-network.component'
import CardSocialNetwork from '@src/components/card-social-network/card-social-network.component'
import { useEffect, useMemo, useState } from 'react'
import './list-social-networks.page.scoped.scss'

interface Props {
  user: User
  openCategoryForProfileId?: string
}

export default ({ user, openCategoryForProfileId }: Props) => {
  const [hiddenBannerText] = useState(false)
  const hubCoreService = useMemo(() => new HubCoreService(), [])
  const [userProfiles, setUserProfiles] = useState<SocialNetworkProfile[]>([])
  const [loading, setLoading] = useState(false)
  const [page, setPage] = useState(1)
  const PAGE_SIZE = 6
  const [hasMore, setHasMore] = useState<boolean>(true)

  const getStatusProviders = (socialNetwork: string, id: string) => {
    switch (socialNetwork) {
      case 'instagram':
        return user?.statusProviders?.instagram?.find((s) => s.id === id)
      case 'youtube':
        return user?.statusProviders['google-oauth2']?.find((s) => s.id === id)
      case 'twitter':
        return user?.statusProviders?.twitter?.find((s) => s.id === id)
      case 'tiktok':
        return user?.statusProviders?.tiktok?.find((s) => s.id === id)
      default:
        return null
    }
  }

  useEffect(() => {
    if (!loading) {
      setLoading(true)
      // @ts-ignore
      hubCoreService.getUserSocialNetworkProfiles('all', page, PAGE_SIZE).then((profiles) => {
        if (profiles?.length) {
          const socialNetworks = profiles.map((profile: SocialNetworkProfile) => {
            return {
              ...profile,
              statusProvider: getStatusProviders(profile.socialNetwork, profile.id),
            }
          })
          setUserProfiles((old) => (old ? [...old, ...socialNetworks] : socialNetworks))
        } else {
          setHasMore(false)
        }
        setLoading(false)
      })
    }
  }, [page])

  return (
    <div className="list-social-networks">
      <BannerSocialNetwork onClick={() => onSocialNetworkConnection.next({ connect: true })} hiddenText={hiddenBannerText} />
      {user?.statusProviders ? (
        <SqInfinityScroll
          elementToScrollId={''}
          loading={loading}
          onLoadMore={() => (!loading ? setPage(page + 1) : null)}
          endMessage={' '}
          hasMore={hasMore}
        >
          <div className="wrapper mt-5 mb-3">
            {userProfiles?.map((item, i) => {
              return (
                <CardSocialNetwork
                  socialNetworkObject={item}
                  key={i}
                  statusProvider={item.statusProvider}
                  user={user}
                  type={item.socialNetwork === 'instagram' ? 'facebook' : item.socialNetwork}
                  openCategory={openCategoryForProfileId === item?.id}
                />
              )
            })}
          </div>
        </SqInfinityScroll>
      ) : null}
    </div>
  )
}
